document.addEventListener("DOMContentLoaded", function(event) {

  let productCardSiblings = document.querySelectorAll('product-card .sibling-picker__option-values .block-swatch');
  productCardSiblings.forEach(productCardSibling => {
    productCardSibling.addEventListener('click', (event) => {
      let closestProductCard = event.target.closest('product-card');
      let quickBuyId = event.target.getAttribute('quick-buy-id');
      let thisproductCardSiblings = closestProductCard.querySelectorAll('.sibling-picker__option-values .block-swatch');
      thisproductCardSiblings.forEach(thisproductCardSibling => {
        if (thisproductCardSibling != event.target) {
          thisproductCardSibling.classList.remove('is-selected');
        } else {
          thisproductCardSibling.classList.add('is-selected');
        }
      });
      if (closestProductCard) {
        if (productCardSibling.hasAttribute('data-variant-product-image')) {
          let main_image = closestProductCard.querySelector('.product-card__image--primary');
          let alt_image = closestProductCard.querySelector('.product-card__image--secondary');

          var newImageElement = document.createElement('img');
          newImageElement.className = 'product-card__image product-card__image--primary';
          newImageElement.setAttribute('width', '1200px');
          newImageElement.setAttribute('src', productCardSibling.getAttribute('data-variant-product-image'));

          var newAltImageElement = document.createElement('img');
          newAltImageElement.className = 'product-card__image product-card__image--secondary';
          newAltImageElement.setAttribute('src', productCardSibling.getAttribute('data-variant-product-alt-image'));
          
          closestProductCard.querySelector('.product-card__media').replaceChild(newImageElement, main_image);
          if(alt_image) {
            closestProductCard.querySelector('.product-card__media').replaceChild(newAltImageElement, alt_image);
          }
        }

        var variantHandle = productCardSibling.getAttribute('data-variant-handle');
        var variantUrl = productCardSibling.getAttribute('data-variant-url');
        var variantTitle = productCardSibling.getAttribute('data-variant-title');
        var variantPrice = productCardSibling.getAttribute('data-variant-price');
        var variantComparePrice = productCardSibling.getAttribute('data-variant-compare-price');
        var variantFullPrice = productCardSibling.getAttribute('data-variant-full-price');
        var variantAvailable = productCardSibling.getAttribute('data-variant-available');

        if (variantFullPrice == "true") {
          closestProductCard.classList.remove("Sale");
          closestProductCard.classList.add("Full");
        } else {
          closestProductCard.classList.remove("Full");
          closestProductCard.classList.add("Sale");
        }
        if (variantAvailable == "true") {
          closestProductCard.classList.remove("Sold-Out");
          closestProductCard.classList.add("Available");
        } else {
          closestProductCard.classList.remove("Available");
          closestProductCard.classList.add("Sold-Out");
        }
        closestProductCard.setAttribute('handle', variantHandle);
        closestProductCard.querySelector('.product-card__figure .product-card__media').setAttribute('href', variantUrl);
        closestProductCard.querySelector('.product-card__info .product-title').innerHTML = variantTitle;
        closestProductCard.querySelector('.product-card__info sale-price').innerHTML = variantPrice;
        closestProductCard.querySelector('.product-card__info compare-at-price').innerHTML = variantComparePrice;
        let quickBuyButtons = closestProductCard.querySelectorAll('.product-card__quick-buy button');
        quickBuyButtons.forEach(quickBuyButton => {
          quickBuyButton.setAttribute('aria-controls', quickBuyId)
        });
      }
    });
  });

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== Node.ELEMENT_NODE) continue;

        // Check if the added node itself is a product-card
        if (node.tagName === 'PRODUCT-CARD') {
          handleProductCard(node);
        }

        // Also check descendants in case product-card is nested inside what was added
        for (const card of node.querySelectorAll('product-card')) {
          handleProductCard(card);
        }
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  function handleProductCard(el) {
    let productCardSiblings = el.querySelectorAll('.sibling-picker__option-values .block-swatch');
    productCardSiblings.forEach(productCardSibling => {
      productCardSibling.addEventListener('click', (event) => {
        let closestProductCard = event.target.closest('product-card');
        let quickBuyId = event.target.getAttribute('quick-buy-id');
        let thisproductCardSiblings = closestProductCard.querySelectorAll('.sibling-picker__option-values .block-swatch');
        thisproductCardSiblings.forEach(thisproductCardSibling => {
          if (thisproductCardSibling != event.target) {
            thisproductCardSibling.classList.remove('is-selected');
          } else {
            thisproductCardSibling.classList.add('is-selected');
          }
        });
        if (closestProductCard) {
          if (productCardSibling.hasAttribute('data-variant-product-image')) {
            let main_image = closestProductCard.querySelector('.product-card__image--primary');
            let alt_image = closestProductCard.querySelector('.product-card__image--secondary');

            var newImageElement = document.createElement('img');
            newImageElement.className = 'product-card__image product-card__image--primary';
            newImageElement.setAttribute('width', '1200px');
            newImageElement.setAttribute('src', productCardSibling.getAttribute('data-variant-product-image'));

            var newAltImageElement = document.createElement('img');
            newAltImageElement.className = 'product-card__image product-card__image--secondary';
            newAltImageElement.setAttribute('src', productCardSibling.getAttribute('data-variant-product-alt-image'));
            
            closestProductCard.querySelector('.product-card__media').replaceChild(newImageElement, main_image);
            if(alt_image) {
              closestProductCard.querySelector('.product-card__media').replaceChild(newAltImageElement, alt_image);
            }
          }

          var variantHandle = productCardSibling.getAttribute('data-variant-handle');
          var variantUrl = productCardSibling.getAttribute('data-variant-url');
          var variantTitle = productCardSibling.getAttribute('data-variant-title');
          var variantPrice = productCardSibling.getAttribute('data-variant-price');
          var variantComparePrice = productCardSibling.getAttribute('data-variant-compare-price');
          var variantFullPrice = productCardSibling.getAttribute('data-variant-full-price');
          var variantAvailable = productCardSibling.getAttribute('data-variant-available');

          if (variantFullPrice == "true") {
            closestProductCard.classList.remove("Sale");
            closestProductCard.classList.add("Full");
          } else {
            closestProductCard.classList.remove("Full");
            closestProductCard.classList.add("Sale");
          }
          if (variantAvailable == "true") {
            closestProductCard.classList.remove("Sold-Out");
            closestProductCard.classList.add("Available");
          } else {
            closestProductCard.classList.remove("Available");
            closestProductCard.classList.add("Sold-Out");
          }
          closestProductCard.setAttribute('handle', variantHandle);
          closestProductCard.querySelector('.product-card__figure .product-card__media').setAttribute('href', variantUrl);
          closestProductCard.querySelector('.product-card__info .product-title').innerHTML = variantTitle;
          closestProductCard.querySelector('.product-card__info sale-price').innerHTML = variantPrice;
          closestProductCard.querySelector('.product-card__info compare-at-price').innerHTML = variantComparePrice;
          let quickBuyButtons = closestProductCard.querySelectorAll('.product-card__quick-buy button');
          quickBuyButtons.forEach(quickBuyButton => {
            quickBuyButton.setAttribute('aria-controls', quickBuyId)
          });
        }
      });
    });
  }

});
